module.exports = __webpack_public_path__ + "media/images/game_icon/th/VGBACCARAT-29b02f0b097af6319913077a0d0ffd59.png";